module.exports = __webpack_public_path__ + "fonts/OpenSans-BoldItalic.081a2a19.woff";